/**
 * Master Muscles — shared shop utilities (locale-aware cart API, language switch, add-to-cart)
 * Loaded early so all theme scripts can use window.MMShop without duplicating locale logic.
 */
(function () {
  'use strict';

  function localeConfig() {
    return window.MM_LOCALE_CONFIG || { current: 'en', primary: 'en', roots: { en: '/', ar: '/ar' } };
  }

  function currentLocaleCode() {
    var cfg = localeConfig();
    return cfg.current || document.documentElement.lang || 'en';
  }

  function localeRoot(code) {
    var cfg = localeConfig();
    var roots = cfg.roots || {};
    if (roots[code] != null) return roots[code];
    return code === (cfg.primary || 'en') ? '/' : '/' + code;
  }

  function shopifyRoot() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var r = window.Shopify.routes.root;
      return r.slice(-1) === '/' ? r : r + '/';
    }
    var root = localeRoot(currentLocaleCode());
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function cartApi(path) {
    return shopifyRoot() + String(path || '').replace(/^\//, '');
  }

  function parseVariantId(id) {
    var n = parseInt(String(id || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  /** Path after stripping the active locale root — matches mm-seo-hreflang.liquid logic. */
  function pathSuffix(pathname) {
    var path = String(pathname || window.location.pathname);
    var curRoot = localeRoot(currentLocaleCode());
    var bare = (curRoot || '/').replace(/\/$/, '');

    if (bare) {
      if (path.indexOf(bare + '/') === 0) {
        path = path.slice(bare.length);
      } else if (path === bare) {
        path = '';
      }
    }

    if (!path) return '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    return path;
  }

  function pathWithoutLocale(pathname) {
    return pathSuffix(pathname);
  }

  function switchLocale(localeCode) {
    if (!localeCode || localeCode === currentLocaleCode()) return;

    var targetRoot = localeRoot(localeCode);
    var suffix = pathSuffix(window.location.pathname);
    var href;

    if (targetRoot === '/' || targetRoot === '') {
      href = suffix;
    } else {
      var base = targetRoot.replace(/\/$/, '');
      href = suffix === '/' ? base + '/' : base + suffix;
    }

    href = href.replace(/([^:]\/)\/+/g, '$1');
    window.location.assign(href + (window.location.search || '') + (window.location.hash || ''));
  }

  function updateReturnToOnForm(form) {
    if (!form) return;
    var input = form.querySelector('input[name="return_to"]');
    if (input) input.value = pathSuffix(window.location.pathname);
  }

  function pulseCartBadges() {
    document
      .querySelectorAll('.cart-count, [data-cart-count], .mm-cart-count, .mm-cart-badge, .mm-bottom-nav-badge')
      .forEach(function (el) {
        el.classList.remove('mm-cart-badge--bounce');
        void el.offsetWidth;
        el.classList.add('mm-cart-badge--bounce');
      });
    var iconWrap = document.querySelector('[data-mm-cart-trigger]');
    if (iconWrap) {
      iconWrap.classList.remove('mm-cart-icon--pulse');
      void iconWrap.offsetWidth;
      iconWrap.classList.add('mm-cart-icon--pulse');
    }
  }

  function showToast(message, isError) {
    // MMCart.showToast renders into the cart sheet banner and silently no-ops
    // when that markup is absent, and it expects a string type rather than a
    // boolean. Only hand off when the banner really exists.
    if (
      window.MMCart &&
      typeof window.MMCart.showToast === 'function' &&
      document.getElementById('mmCartSheetSuccess') &&
      document.getElementById('mmCartSheetSuccessText')
    ) {
      window.MMCart.showToast(message, isError ? 'error' : '');
      return;
    }
    var toast = document.getElementById('mmShopToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mmShopToast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message || '';
    toast.className = 'mm-shop-toast' + (isError ? ' mm-shop-toast--error' : ' mm-shop-toast--ok');
    toast.hidden = false;
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.hidden = true;
    }, 3200);
  }

  function miniFly(sourceEl, imageUrl) {
    if (!imageUrl || !sourceEl) return;
    var target =
      document.querySelector('[data-mm-cart-trigger] .mm-action-icon') ||
      document.querySelector('.mm-action-link[href*="/cart"] .mm-action-icon') ||
      document.querySelector('.mm-cart-badge');
    if (!target) return;
    var srcRect = sourceEl.getBoundingClientRect();
    var tgtRect = target.getBoundingClientRect();
    var fly = document.createElement('img');
    fly.className = 'mm-cart-fly';
    fly.src = imageUrl;
    fly.alt = '';
    fly.style.left = srcRect.left + srcRect.width / 2 - 22 + 'px';
    fly.style.top = srcRect.top + srcRect.height / 2 - 22 + 'px';
    fly.style.transition =
      'left 0.38s cubic-bezier(0.22, 1, 0.36, 1), top 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease, transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
    document.body.appendChild(fly);
    requestAnimationFrame(function () {
      fly.style.left = tgtRect.left + tgtRect.width / 2 - 10 + 'px';
      fly.style.top = tgtRect.top + tgtRect.height / 2 - 10 + 'px';
      fly.style.opacity = '0.25';
      fly.style.transform = 'scale(0.3)';
    });
    setTimeout(function () {
      fly.remove();
    }, 420);
  }

  function fallbackAddToCart(variantId, options) {
    options = options || {};
    var vid = parseVariantId(variantId);
    if (!vid) return Promise.reject(new Error('invalid variant'));

    var qty = parseInt(options.quantity, 10) || 1;
    var sourceEl = options.sourceElement;
    var imageUrl = options.imageUrl;

    return fetch(cartApi('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: vid, quantity: qty }),
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (e) {
            data = null;
          }
          if (!r.ok) throw data || new Error('add failed');
          return data;
        });
      })
      .then(function (item) {
        if (imageUrl || (item && item.image)) miniFly(sourceEl, imageUrl || item.image);
        pulseCartBadges();
        var refresh = window.MMCart && typeof window.MMCart.refresh === 'function'
          ? window.MMCart.refresh()
          : fetch(cartApi('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            });
        return refresh.then(function (cart) {
          if (cart && typeof cart.item_count === 'number' && window.MMCart && window.MMCart.updateBadges) {
            window.MMCart.updateBadges(cart.item_count, true);
          } else if (cart && typeof cart.item_count === 'number') {
            document.querySelectorAll('.mm-cart-badge, .mm-cart-count, [data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('mm:cart-updated', { detail: cart || item }));
          if (options.openSheet !== false && window.MMCart && typeof window.MMCart.open === 'function') {
            window.MMCart.open({ cart: cart, skipRefresh: true });
          }
          return cart || item;
        });
      });
  }

  function addToCart(variantId, options) {
    options = options || {};
    var vid = parseVariantId(variantId);
    if (!vid) return Promise.reject(new Error('invalid variant'));

    if (window.MMCart && typeof window.MMCart.add === 'function') {
      return window.MMCart.add(vid, options.quantity || 1, {
        openSheet: options.openSheet !== false,
        sourceElement: options.sourceElement,
        imageUrl: options.imageUrl,
        quickAdd: options.quickAdd === true,
      });
    }

    return fallbackAddToCart(vid, options);
  }

  window.MMShop = {
    root: shopifyRoot,
    cartApi: cartApi,
    parseVariantId: parseVariantId,
    pathWithoutLocale: pathWithoutLocale,
    pathSuffix: pathSuffix,
    switchLocale: switchLocale,
    updateReturnToOnForm: updateReturnToOnForm,
    addToCart: addToCart,
    showToast: showToast,
  };

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = String(form.getAttribute('action') || '');
      if (action.indexOf('/localization') === -1 && !form.classList.contains('mm-markets-form')) return;
      updateReturnToOnForm(form);
    },
    true
  );
})();
